<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    const dispatch = createEventDispatcher()
    import Fa from 'svelte-fa'
    import { faAngleLeft, faEdit, faPlus, faPlusCircle, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    import Content from '../../_common/content.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import { Goalboard } from '../../../modules/toolsApi/goalboards/goalboard.entity'
    import type { CreateGoalboardDto } from '../../../modules/toolsApi/goalboards/dto/create-goalboard.dto'
    import type { UpdateGoalboardDto } from '../../../modules/toolsApi/goalboards/dto/update-goalboard.dto'
    import type { User } from '../../../modules/usersApi/users/user'
    import InlineSelect from '../../_common/inline-select.svelte'
    import Zact from '../../_common/z/zact.svelte'

    // ##############################################################################################################

    export let form: boolean = false
    export let goalboardId: string = null

    let entity: Goalboard = new Goalboard()
    let entities: Goalboard[] = []
    let usersAll: boolean = true

    let days: { label: string; value: number }[] = []
    days.push({ label: 'dom', value: 0 })
    days.push({ label: 'seg', value: 1 })
    days.push({ label: 'ter', value: 2 })
    days.push({ label: 'qua', value: 3 })
    days.push({ label: 'qui', value: 4 })
    days.push({ label: 'sex', value: 5 })
    days.push({ label: 'sab', value: 6 })

    let users: User[] = []

    async function loadUsers() {
        users = await window.api.users.companies.getCompanyUsers(600)
    }

    async function editEntity(id: string) {
        try {
            show = true
            await loadUsers()
            entity = new Goalboard()
            entity = await window.api.tools.goalboards.getOne(id)
            usersAll = entity.users.length === 0
            console.log('goalboard', entity)
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function newEntity() {
        await loadUsers()
        entity = new Goalboard()
        entity.users = []
        entity.workingDays = [1, 2, 3, 4, 5, 6]
        entity.goalWindowDays = 30
        entity.conversionWindowDays = 30
        entity.refreshTime = 0
        entity.resultType = 'absolute' // o relative foi abandonado pois não é possível se ter uma taxa de conversão percentual direta, pois os agendamentos que compareceram não estão vincula
        usersAll = true
        step = 2
    }

    async function createEntity() {
        try {
            show = true
            if (usersAll) entity.users = []
            const dto: CreateGoalboardDto = {
                contactedGoal: entity.contactedGoal,
                connectedGoal: entity.connectedGoal,
                conversionGoal: entity.conversionGoal,
                conversionWindowDays: entity.conversionWindowDays,
                goalWindowDays: entity.goalWindowDays,
                label: entity.label,
                refreshTime: entity.refreshTime,
                scheduledGoal: entity.scheduledGoal,
                showGoal: entity.showGoal,
                users: entity.users,
                workingDays: entity.workingDays,
                resultType: 'absolute',
                showIcon: entity.showIcon,
                goalType: entity.goalType,
            }
            entity = await window.api.tools.goalboards.create(dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function sendClose() {
        dispatch('close')
    }

    async function updateEntity() {
        try {
            show = true
            if (usersAll) entity.users = []
            const dto: UpdateGoalboardDto = {
                contactedGoal: entity.contactedGoal,
                connectedGoal: entity.connectedGoal,
                conversionGoal: entity.conversionGoal,
                conversionWindowDays: entity.conversionWindowDays,
                goalWindowDays: entity.goalWindowDays,
                label: entity.label,
                refreshTime: entity.refreshTime,
                scheduledGoal: entity.scheduledGoal,
                showGoal: entity.showGoal,
                users: entity.users,
                workingDays: entity.workingDays,
                resultType: entity.resultType,
                showIcon: entity.showIcon,
                goalType: entity.goalType,
            }
            await window.api.tools.goalboards.update(entity.goalboardId, dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function saveEntity() {
        if (entity.goalboardId) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function loadEntities() {
        try {
            show = true
            step = 1
            entities = await window.api.tools.goalboards.getAll()
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Metas'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Nome da meta' }))
        grid.cols.push(new GridCol({ content: 'Data de criação', type: GridColTypeEnum.datetime, size: 2 }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            const btnPerson = new GridButton({
                callback: () => editEntity(item.goalboardId),
                icon: faEdit,
                label: 'Editar',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.label })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: [btnPerson] })
            grid.lines.push(line)
        }
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await window.api.tools.goalboards.remove(entity.goalboardId)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
    }

    let show = false
    let step = 1

    let expand = true
    onMount(async () => {
        await loadEntities()
        if (form) {
            expand = false
            if (goalboardId) {
                await editEntity(goalboardId)
            } else {
                await newEntity()
            }
        }
    })
</script>

{#if !show}
    {#if step === 1}
        <Content>
            <Zact>
                <div class="spacer" />
                {#if window.store.token.permissions.tools.goals.write}
                    <button class="btn btn-primary" on:click={newEntity}><Fa icon={faPlusCircle} /> Nova meta</button>
                {/if}
            </Zact>
            <Zgrid class="h-space" {grid} />
            <LoadSpinner {show} />
        </Content>
    {/if}
    {#if step === 2}
        <Content>
            <Zact>
                {#if !form}
                    <button class="btn btn-secondary" on:click={showEntities}><Fa icon={faAngleLeft} /> Voltar</button>
                {/if}
                <div class="spacer" />
                {#if window.store.token.permissions.tools.goals.write}
                    {#if !!entity.goalboardId}
                        <button class="btn btn-warning" on:click={removeEntity}><Fa icon={faTrashAlt} /> Excluir</button>
                    {/if}
                    <button class="btn btn-primary" on:click={saveEntity}><Fa icon={faSave} /> Salvar</button>
                {/if}
            </Zact>

            <Zframe class="h-space" title="">
                <div class="grid-form">
                    <div class="row">
                        <div class="col">
                            <div class="input-group">
                                <label for="" class="input-group-text">Nome da meta</label>
                                <input type="text" bind:value={entity.label} class="form-control" />
                            </div>
                            <div class="text-muted">Escolha um nome para sua meta. Ex.: Geral / SDRs / Vendedores</div>
                        </div>
                        <div class="col">
                            <div class="date input-group">
                                <div class="input-group">
                                    <label for="" class="input-group-text">Atualização automática da tela</label>
                                    <select class="form-select" bind:value={entity.refreshTime}>
                                        <option value={0}>Não atualizar</option>
                                        <option value={5}>A cada 5 minutos</option>
                                        <option value={15}>A cada 15 minutos</option>
                                        <option value={30}>A cada 30 minutos</option>
                                        <option value={60}>A cada 60 minutos</option>
                                    </select>
                                </div>
                                <div class="text-muted">Programe a tela para se atualizar automaticamente</div>
                            </div>
                        </div>
                    </div>
                </div></Zframe
            >
            <Zframe title="Usuários nesta meta" class="h-space">
                <div class="grid-form">
                    <div class="row">
                        <div class="col mt-1">
                            <div class="form-check form-switch">
                                <input class="form-check-input" bind:checked={usersAll} type="checkbox" role="switch" id="entity.users" />
                                <label class="form-check-label" for="entity.users">Todos os usuários</label>
                            </div>
                        </div>
                    </div>
                    {#if !usersAll}
                        <div class="row">
                            <div class="col-6">
                                <select name="usersSelected" id="usersSelected" multiple size="7" bind:value={entity.users} class="form-control">
                                    {#each users as user}
                                        {#if entity.users?.includes(user.userId)}
                                            <option selected value={user.userId}>{user.userName}</option>
                                        {:else}
                                            <option value={user.userId}>{user.userName}</option>
                                        {/if}
                                    {/each}
                                </select>
                                <div class="text-muted">Segure CTRL para selecionar mais de um usuário</div>
                            </div>
                        </div>
                    {/if}
                    <div class="row">
                        <div class="col">
                            <div class="form-check form-switch">
                                <input class="form-check-input" bind:checked={entity.showIcon} type="checkbox" role="switch" id="showIcon" />
                                <label class="form-check-label" for="showIcon">Exibir ícone de metas na barra de menus para o usuário</label>
                            </div>
                        </div>
                    </div>
                </div>
            </Zframe>

            <Zframe title="Metas" class="h-space" headline="Informe o valor 0 caso queira desativar uma meta específica.">
                <div class="grid-form">
                    <div class="row">
                        <div class="col-4">
                            <div class="input-group">
                                <label for="" class="input-group-text">Tipo de meta</label>
                                <select class="form-select" bind:value={entity.goalType} name="" id="">
                                    <option value="global">Meta para todos os usuários</option>
                                    <option value="individual">Meta individual</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <div class="date input-group">
                                <label for="" class="input-group-text">Contatos a serem tentados</label>
                                <input type="number" bind:value={entity.contactedGoal} class="form-control" />
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="date input-group">
                                <label for="" class="input-group-text">Contatos a serem concretizados</label>
                                <input type="number" bind:value={entity.connectedGoal} class="form-control" />
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="date input-group">
                                <label for="" class="input-group-text">Agendamentos a serem criados</label>
                                <input type="number" bind:value={entity.scheduledGoal} class="form-control" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        {#if entity.goalboardId && entity.resultType === 'relative'}
                            <div class="col-4">
                                <div class="input-group">
                                    <label for="" class="input-group-text">Tipo de resultado</label>
                                    <select class="form-select" bind:value={entity.resultType} name="" id="">
                                        <option value="relative">Relativo (%)</option>
                                        <option value="absolute">Absoluto</option>
                                    </select>
                                </div>
                            </div>
                        {/if}
                        <div class="col-4">
                            <div class="date input-group">
                                <label for="" class="input-group-text">Comparecimento no agendamento</label>
                                <input type="number" bind:value={entity.showGoal} class="form-control" />
                                <label for="" class="input-group-text">{entity.resultType === 'relative' ? '%' : ''}</label>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="date input-group">
                                <label for="" class="input-group-text">Conversão</label>
                                <input type="number" bind:value={entity.conversionGoal} class="form-control" />
                                <label for="" class="input-group-text">{entity.resultType === 'relative' ? '%' : ''}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </Zframe>
            <Zframe title="Configurações" class="h-space">
                <div class="grid-form">
                    <div class="row">
                        <div class="col">
                            <InlineSelect multi={true} label="Dias trabalhados na semana" bind:value={entity.workingDays} options={days} />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <div class="date input-group">
                                <label for="" class="input-group-text">Período das metas</label>
                                <select class="form-select" bind:value={entity.goalWindowDays}>
                                    <option value={1}>Diário</option>
                                    <option value={7}>Semanal</option>
                                    <option value={15}>Quinzenal</option>
                                    <option value={30}>Mensal</option>
                                </select>
                            </div>
                            <div class="text-muted">Escolha entre metas semanais, quinzenais e mensais</div>
                        </div>
                        <div class="col-6">
                            <div class="date input-group">
                                <label for="" class="input-group-text">Janela de conversão</label>
                                <input type="number" bind:value={entity.conversionWindowDays} class="form-control" />
                            </div>
                            <div class="text-muted">Dias após o atendimento uma compra ainda será considerada conversão</div>
                        </div>
                    </div>
                </div>
            </Zframe>
            {#if !form}
                <div class="m-bottom-sm" />
            {:else}
                <div class="mb-3" />
            {/if}
        </Content>
    {/if}
{/if}

<style>
    .limit-width {
        max-width: 400px;
    }
</style>
